import createNeighborWeightsV1 from "./createNeighborWeightsV1"
import createXYCacheFactory from "./createXYCacheFactory"

const getNeighborWeightsV1Cached = createXYCacheFactory(createNeighborWeightsV1)

export default getNeighborWeightsV1Cached
